import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './Components/Navigation';
import BottomNav from './Components/BottomNav';
import HomePage from './Components/HomePage';
import AboutPage from './Components/AboutPage';
import StatusPage from './Components/StatusPage';
import Team from './Components/Team';
import FAQ from './Components/FAQ';
import ContactForm from './Components/ContactForm';
import './App.css';

function App() {
  return (
    <Router>
      <Navigation/>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/about" element={<AboutPage/>} />
        <Route path="/status" element={<StatusPage/>} />
        <Route path="/team" element={<Team/>}/>
        <Route path="/faq" element={<FAQ/>}/>
        <Route path="/contact" element={<ContactForm/>}/>
      </Routes>
      <BottomNav/>
    </Router>
  );
}

export default App;
